module.exports = __webpack_public_path__ + "img/transit-icon-img.e4486d0e.svg";